var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M496 308v178H393V320c0-41.8-14.8-70.2-52-70.2-28.4 0-45.3 19-52.8 37.7-2.7 6.6-3.4 16-3.4 25.2V486h-103s1.5-281.2 0-310.4h103v44l-.7 1h.8v-1c13.7-21 38-51.3 92.7-51.3 67.7 0 118.5 44.4 118.5 139.7zM74.2 26C39 26 16 49.2 16 79.6c0 29.8 22.4 53.7 57 53.7h.6c35.8 0 58.2-24 58.2-53.7C131 49.2 109.4 26 74.2 26zm-52 460H125V175.6H22V486z","fill":"#0077b5"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 512 512","height":"512","width":"512"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
